import { useTranslation } from 'react-i18next'
import { MODULE_NAME } from 'modules/Invoices/strings'

export const useGetLabel = () => {
  const { t } = useTranslation(MODULE_NAME)

  const getLabel = (daysLeft: number) => {
    if (daysLeft < 0)
      return t('list.deadline.daysAfterDeadline', { count: Math.abs(daysLeft) })
    if (daysLeft > 0) return t('list.deadline.days', { count: daysLeft })
    return t('list.deadline.today')
  }

  return getLabel
}
